<div class="vstack h-100">
    <div class="offcanvas-header px-4">
        <h5 class="offcanvas-title fw-semibold">
            {{ booking.order?.isPaid ? 'Edit Order Note' : booking.order ? 'Edit Order' : 'Add Order' }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
    <div class="offcanvas-body p-0 vstack gap-3">
        @if (booking.order?.isPaid) {
            <div class="px-4" [formGroup]="form">
                <label for="paid-order-note" class="form-label">Order note</label>
                <textarea id="paid-order-note" class="form-control" formControlName="message" rows="4"></textarea>
            </div>
        } @else {
        @if (items.length === 0) {
            <div class="vstack gap-3 text-center p-4 align-items-center flex-grow-0">
                <div class="rounded-circle bg-body-tertiary p-3">
                    <img
                        ngSrc="assets/food-drink/normal.svg"
                        alt="No items"
                        class="img-fluid"
                        height="36"
                        width="36"
                    />
                </div>
                <div class="vstack gap-2">
                    <h5 class="fw-semibold my-0">
                        No products in this order
                    </h5>
                    <div class="">
                        Add products to this order to record items the customer has requested.
                    </div>
                </div>
            </div>
        } @else {
            <div class="table-responsive">
                <table class="table table-inline align-middle mb-0">
                    <thead>
                        <tr>
                            <th>
                                <span class="ms-4">Product Name</span>
                            </th>
                            <th class="text-end">
                                <span class="me-3">Quantity</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items">
                            <td>
                                <span class="ms-4 fw-semibold">{{ item.name }}</span>
                            </td>
                            <td class="text-end">
                                <div class="me-3 d-inline-flex align-items-center gap-2">
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary"
                                        [disabled]="getQuantity(item) === 0"
                                        (click)="decrement(item)"
                                    >
                                        –
                                    </button>
                                    <span
                                        class="d-inline-block text-center fw-semibold"
                                        style="min-width:2rem;"
                                    >
                                        {{ getQuantity(item) }}
                                    </span>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary"
                                        (click)="increment(item)"
                                    >
                                        +
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        [disabled]="getQuantity(item) === 0"
                                        (click)="removeLineItem(item)"
                                        title="Remove"
                                    >
                                        <img
                                            ngSrc="assets/trash/normal_red.svg"
                                            alt="Remove"
                                            height="16"
                                            width="16"
                                        />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }
        @if (productLibrary) {
            <div class="px-4">
                <div class="btn-group" ngbDropdown autoClose="inside">
                    <button
                        type="button"
                        class="btn btn-outline-primary btn-sm dropdown-toggle"
                        ngbDropdownToggle 
                        [disabled]="addableConsumables.length === 0"
                    >
                        Add Product
                    </button>
                    <div
                        class="dropdown-menu dropdown-menu-end p-0"
                        ngbDropdownMenu
                        style="min-width: 320px; max-height: 320px; overflow: auto;"
                    >
                        <div class="px-3 py-2">
                            <input
                                type="text"
                                class="input-plain w-100"
                                placeholder="Search products"
                                [value]="addSearchTerm"
                                (input)="onAddSearch($any($event.target).value)"
                            />
                        </div>
                        <hr class="my-0" />
                        <ng-container *ngIf="filteredConsumables.length; else noProducts">
                            <button 
                                class="m-1 dropdown-item d-flex justify-content-between align-items-center"
                                *ngFor="let c of filteredConsumables"
                                (click)="addConsumable(c)"
                                ngbDropdownItem
                            >
                                <span class="p-1 text-truncate">
                                    {{ c.displayName }}
                                </span>
                            </button>
                        </ng-container>
                        <ng-template #noProducts>
                            <div class="text-body-secondary small px-3 py-2">
                                No products found.
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        }
        }
    </div>
    <div class="offcanvas-footer p-3 border-top d-flex justify-content-end gap-2">
        <button
            class="btn btn-outline-secondary"
            (click)="cancel()"
        >
            Cancel
        </button>
        <button
            class="btn btn-primary"
            (click)="save()"
            [disabled]="!booking.order?.isPaid && lineItemsArray.length === 0"
        >
            Save Changes
        </button>
    </div>
</div>
